import { createFileRoute } from '@tanstack/react-router'
import AdminRunDetailPage from '@/components/pages/Admin/AdminRunDetailPage/AdminRunDetailPage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/runs/$runId')({
  component: AdminRunDetailRoute,
})

function AdminRunDetailRoute() {
  return <AdminRunDetailPage />
}
